import commsAPI from '@/api/comms';

const getDefaultState = () => ({
  commsListConfig: {
    pagination: {
      page: null,
      page_size: null,
      sort: null,
      ordering: null,
    },
    queryParams: {
      email: null,
      phone_number: null,
    },
    paginationCount: 0,
  },
  
  contacts: [],
  contactsLoading: false,
  contactsError: false,
  contactsErrorResponse: null,

  commsList: [],
  fetchCommsListLoading: false,
  fetchCommsListError: false,
  fetchCommsListErrorResponse: null,

  downloadFreshDeskRecordingLoading: false,
  downloadFreshDeskRecordingError: false,
  downloadFreshDeskRecordingErrorResponse: null,

  commDetail: {},
});

const state = getDefaultState();

const mutations = {
  FETCH_CONTACTS_BEGIN(state) {
    state.contactsLoading = true;
    state.contactsError = false;
    state.contactsErrorResponse = null;
  },
  FETCH_CONTACTS_SUCCESS(state, payload) {
    state.contacts = payload;
    state.contactsLoading = false;
  },
  FETCH_CONTACTS_ERROR(state, err) {
    state.contactsLoading = false;
    state.contactsError = true;
    state.contactsErrorResponse = err;
  },
  
  FETCH_COMMS_LIST_BEGIN(state) {
    state.fetchCommsListLoading = true;
    state.fetchCommsListError = false;
    state.fetchCommsListErrorResponse = null;
  },
  FETCH_COMMS_LIST_SUCCESS(state, payload) {
    state.commsList = payload.results;
    state.commsListConfig.paginationCount = payload.count;
    state.fetchCommsListLoading = false;
  },
  FETCH_COMMS_LIST_ERROR(state, err) {
    state.fetchCommsListLoading = false;
    state.fetchCommsListError = true;
    state.fetchCommsListErrorResponse = err;
  },
  
  UPDATE_COMMS_LIST_CONFIG_FILTERS(state, payload) {
    state.commsListConfig.pagination.page = 1;
    state.commsListConfig.queryParams.email = [...payload.email];
    state.commsListConfig.queryParams.phone_number = [...payload.phone_number];
  },
  UPDATE_COMMS_LIST_CONFIG_PAGINATION(state, { pagination, queryParams }) {
    const queryKeyMap = {
      email: "email__in",
      phone_number: "phone_number__in",
    };

    if(pagination) {
      for(let param in state.commsListConfig.pagination) {
        if(pagination[param]) {
          state.commsListConfig.pagination[param] = pagination[param];
        }
      }
    }

    if(queryParams) {
      for(let param in state.commsListConfig.queryParams) {
        if(queryParams.hasOwnProperty(param)) {
          if(queryKeyMap[param].includes("__in") && typeof queryParams[param] === "string") {
            state.commsListConfig.queryParams[param] = queryParams[param].split(",");
          } else {
            state.commsListConfig.queryParams[param] = queryParams[param];
          }
        }
      }
    }
  },

  DOWNLOAD_FRESHDESK_RECORDING_BEGIN(state) {
    state.downloadFreshDeskRecordingLoading = true;
    state.downloadFreshDeskRecordingError = false;
    state.downloadFreshDeskRecordingErrorResponse = null;
  },
  DOWNLOAD_FRESHDESK_RECORDING_SUCCESS(state) {
    state.downloadFreshDeskRecordingLoading = false;
  },
  DOWNLOAD_FRESHDESK_RECORDING_ERROR(state, err) {
    state.downloadFreshDeskRecordingLoading = false;
    state.downloadFreshDeskRecordingError = true;
    state.downloadFreshDeskRecordingErrorResponse = err;
  },

  SET_COMM_DETAIL(state, payload) {
    state.commDetail = payload;
  },

  RESET_COMMS_STORE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async fetchContacts({commit}, {id, type}) {
    commit('FETCH_CONTACTS_BEGIN');
    try {
      const response = type === 'product' ? await commsAPI.fetchProductContacts(id) : await commsAPI.fetchAccountContacts(id);
      commit('FETCH_CONTACTS_SUCCESS', response.data);
    } catch(err) {
      commit('FETCH_CONTACTS_ERROR', err);
    }
  },

  async fetchCommsList({state, commit}) {
    commit('FETCH_COMMS_LIST_BEGIN'); 
    
    const url = new URL(window.location);
    const query = {};

    Object.entries({ ...state.commsListConfig.pagination, ...state.commsListConfig.queryParams }).forEach(([k,v]) => {
      if(v && !Array.isArray(v) || (Array.isArray(v) && v.length)) {
        query[k] = v;
        url.searchParams.set(k,v);
      } else {
        url.searchParams.delete(k);
      }
    });

    window.history.pushState(null, '', url.toString());

    try {
      const response =  await commsAPI.fetchCommsList(query);
      commit('FETCH_COMMS_LIST_SUCCESS', response.data);
    } catch(err) {
      commit('FETCH_COMMS_LIST_ERROR', err);
    }
  },

  async downloadFreshdeskRecording({ dispatch, commit }, recording_url) {
    commit('DOWNLOAD_FRESHDESK_RECORDING_BEGIN');

    try {
      const response = await commsAPI.downloadFreshdeskRecording(recording_url);
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      const file = `${recording_url}.wav`;
      link.setAttribute('download', file);
      document.body.appendChild(link);
      link.click();
      commit('DOWNLOAD_FRESHDESK_RECORDING_SUCCESS');
    } catch (err) {
      const error = JSON.parse(await err.response.data.text());
      commit('DOWNLOAD_FRESHDESK_RECORDING_ERROR', err);
      dispatch("alerts/setAlert", { type: "error", message: error }, { root: true });
    }
  },

  updateCommsListConfigFilters({commit, dispatch}, payload) {
    commit('UPDATE_COMMS_LIST_CONFIG_FILTERS', payload);
    dispatch('fetchCommsList');
  },

  updateCommsListConfigPagination({commit, dispatch}, payload) {
    commit('UPDATE_COMMS_LIST_CONFIG_PAGINATION', payload);
    dispatch('fetchCommsList');
  }
};

const getters = {
  getCommsListConfig: state => state.commsListConfig,
  
  getCommsList: state => state.commsList,
  getFetchCommsListLoading: state => state.fetchCommsListLoading,
  getFetchCommsListError: state => state.fetchCommsListError,
  getFetchCommsListErrorResponse : state => state.fetchCommsListErrorResponse,

  getContacts: state => state.contacts,
  getContactsLoading: state => state.contactsLoading,
  getContactsError: state => state.contactsError,
  getContactsErrorResponse: state => state.contactsErrorResponse,

  getDownloadFreshdeskRecordingLoading: state => state.downloadFreshDeskRecordingLoading,
  getDownloadFreshdeskRecordingError: state => state.downloadFreshDeskRecordingError,
  getDownloadFreshdeskRecordingErrorResponse: state => state.downloadFreshDeskRecordingErrorResponse,

  getCommDetail: state => state.commDetail,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};